import React from 'react';

import './style.scss';
import UnitsService from '../../../Services/api/Units';
import ActionItemsService, {
  STATUS_PENDING,
  STATUS_APPROVAL_RETURN_TO_SUBMITTER,
  STATUS_APPROVAL_IN_PROGRESS
} from '../../../Services/api/ActionItems';
import HeaderSelector from './HeaderSelector';
import HeaderStats from './HeaderStats';
import Button from '../../Common/Button';

import ConfigService from '../../../Services/api/Config';

class LfaHeader extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      stats: null,
      buildings: {},
      totalUnits: 0,
      currentUnit: null,
      currentBuilding: null
    };
    this.buildingsArray = [];
  }

  UNSAFE_componentWillMount() {
    this.initStats();
  }

  componentDidMount() {
    this.setUnitBuildings();
  }

  componentWillUnmount() {
    clearInterval(this.statsInterval);
  }

  initStats = async () => {
    const { unit, handleUpdateStats, status, task, filters } = this.props;
    if (unit) {
      if (this.statsInterval) {
        clearInterval(this.statsInterval);
      }
      const newStats = await ActionItemsService.getStatistics(task, filters);
      this.setState({ stats: newStats });
      await handleUpdateStats(newStats);
      if ([STATUS_PENDING, STATUS_APPROVAL_IN_PROGRESS, STATUS_APPROVAL_RETURN_TO_SUBMITTER].includes(status)) {
        this.statsInterval = setInterval(() => {
          const { stats } = this.state;
          if (stats) {
            this.setState({
              stats: {
                ...stats,
                time_spent: {
                  ...stats.time_spent,
                  current: stats.time_spent.current + 1
                }
              }
            });
          }
        }, 1000);
      }
    }
  };

  setNewStats = async () => {
    const { task, handleUpdateStats, filters } = this.props;
    const newStats = await ActionItemsService.getStatistics(task, filters);
    const { stats } = this.state;
    this.setState({
      stats: {
        status: newStats.status,
        time_spent: {
          ...stats.time_spent,
          my_average: newStats.time_spent.my_average,
          total_average: newStats.time_spent.total_average
        }
      }
    });
    await handleUpdateStats(newStats);
  };

  setUnitBuildings = async () => {
    const { unit, task, filters } = this.props;
    const units = await UnitsService.getWorkflow(task, filters);

    if (units && units.results) {
      const { results } = units;
      const totalUnits = results.length;
      const buildings = {};
      for (const result of results) {
        if (buildings[result.building]) {
          buildings[result.building].units.push({ id: result.id, number: result.number });
        } else {
          buildings[result.building] = { units: [{ id: result.id, number: result.number }] };
        }
      }
      for (const building in buildings) {
        buildings[building].units.sort((a, b) => {
          if (a.number > b.number) {
            return 1;
          }
          if (a.number < b.number) {
            return -1;
          }
          return 0;
        });
      }
      this.buildingsArray = Object.keys(buildings).sort();
      if (unit.building === null) {
        unit.building = 'null';
      }
      const currentBuilding = this.buildingsArray.indexOf(unit.building);
      const currentUnit = buildings[unit.building].units.findIndex((item) => item.id === unit.id);
      this.setState({ buildings, totalUnits, currentBuilding, currentUnit });
    }
  };

  setPrevBuilding = async (preventSave) => {
    const { currentBuilding, buildings, stats } = this.state;
    const { handleUpdateStats, getNewContextData } = this.props;
    await handleUpdateStats(stats);
    if (currentBuilding) {
      const unit = buildings[this.buildingsArray[currentBuilding - 1]].units[0].id;
      const nextContext = await getNewContextData(unit, preventSave);
      if (nextContext) {
        this.setState({ currentBuilding: currentBuilding - 1, currentUnit: 0 });
        this.initStats();
      }
    }
  };

  setPrevUnit = async (preventSave) => {
    const { currentUnit, currentBuilding, buildings, stats } = this.state;
    const { handleUpdateStats, getNewContextData } = this.props;
    await handleUpdateStats(stats);
    if (currentUnit) {
      const unit = buildings[this.buildingsArray[currentBuilding]].units[currentUnit - 1].id;
      const nextContext = await getNewContextData(unit, preventSave);
      if (nextContext) {
        this.setState({ currentUnit: currentUnit - 1 });
        this.initStats();
      }
    }
  };

  setNextBuilding = async (preventSave) => {
    const { currentBuilding, buildings, stats } = this.state;
    const { handleUpdateStats, getNewContextData } = this.props;
    await handleUpdateStats(stats);
    if (currentBuilding < this.buildingsArray.length - 1) {
      const unit = buildings[this.buildingsArray[currentBuilding + 1]].units[0].id;
      const nextContext = await getNewContextData(unit, preventSave);
      if (nextContext) {
        this.setState({ currentBuilding: currentBuilding + 1, currentUnit: 0 });
        this.initStats();
      }
    }
  };

  setNextUnit = async (preventSave) => {
    const { currentUnit, currentBuilding, buildings, stats } = this.state;
    const { handleUpdateStats, getNewContextData } = this.props;
    await handleUpdateStats(stats);
    if (currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1) {
      const unit = buildings[this.buildingsArray[currentBuilding]].units[currentUnit + 1].id;
      const nextContext = await getNewContextData(unit, preventSave);
      if (nextContext) {
        this.setState({ currentUnit: currentUnit + 1 });
        this.initStats();
      }
    }
  };

  setNext = async (preventSave) => {
    const { currentUnit, currentBuilding, buildings, stats } = this.state;
    const { handleUpdateStats, getNewContextData } = this.props;
    await handleUpdateStats(stats);
    if (currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1) {
      const unit = buildings[this.buildingsArray[currentBuilding]].units[currentUnit + 1].id;
      const nextContext = await getNewContextData(unit, preventSave);
      if (nextContext) {
        this.setState({ currentUnit: currentUnit + 1 });
        this.initStats();
      }
    } else {
      this.setNextBuilding(preventSave);
    }
  };

  onClickFinish = async () => {
    const { handleFinish, task, handleUpdateStats, getNewContextData, filters } = this.props;
    const { currentUnit, currentBuilding, buildings, stats } = this.state;
    await handleUpdateStats(stats);
    if (currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1) {
      const response = await handleFinish(true);
      if (response && response.id) {
        await ActionItemsService.complete(task, filters);
        const unit = buildings[this.buildingsArray[currentBuilding]].units[currentUnit + 1].id;
        const nextContext = await getNewContextData(unit, true);
        if (nextContext) {
          this.setState({ currentUnit: currentUnit + 1 });
          this.initStats();
        }
      }
    } else if (currentBuilding < this.buildingsArray.length - 1) {
      const response = await handleFinish(true);
      if (response && response.id) {
        await ActionItemsService.complete(task, filters);
        const unit = buildings[this.buildingsArray[currentBuilding + 1]].units[0].id;
        const nextContext = await getNewContextData(unit, true);
        if (nextContext) {
          this.setState({ currentBuilding: currentBuilding + 1, currentUnit: 0 });
          this.initStats();
        }
      }
    } else {
      await handleFinish();
    }
  };

  onClickSave = async () => {
    const { handleSave } = this.props;
    await handleSave();
    this.setNewStats();
  };

  reopen = async () => {
    const { handleReopen } = this.props;
    await handleReopen();
    this.initStats();
  };

  render() {
    const { property, unit, dfName, handleClear, actionItemStatus, showStatistics, force, action } = this.props;
    const { currentBuilding, currentUnit, buildings, totalUnits, stats } = this.state;
    if (!buildings[unit.building]) {
      return false;
    }

    const finishString =
      currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1 || currentBuilding < this.buildingsArray.length - 1
        ? 'Save & continue'
        : 'Finish';

    return (
      <div className="LfaHeader">
        <div className="LfaHeader_Stats">{stats && showStatistics && <HeaderStats stats={stats} />}</div>
        <div className="LfaHeader_Property">
          <h2>
            {force && (
              <span className="Red" style={{ color: ConfigService.getColor('errorColor') }}>
                {action}
              </span>
            )}
            {dfName}
          </h2>
          <h3 style={{ color: ConfigService.getColor('secondaryColor') }}>{property.name}</h3>
        </div>
        <div className="LfaHeader_Actions">
          {(actionItemStatus === 0 && (
            <>
              <div className="WrapperDynamicForm_Actions Center">
                <Button className="Button_Small Button_Delete Inline" onClick={handleClear}>
                  Clear
                </Button>
                <Button className="Button_Small Inline" onClick={this.onClickSave}>
                  Save Progress
                </Button>
                <Button className="Button_Small Inline" onClick={this.onClickFinish}>
                  {finishString}
                </Button>
              </div>
              <div className="LfaHeader_Buttons">
                <HeaderSelector
                  label="Building"
                  value={this.buildingsArray[currentBuilding]}
                  onClickPrev={this.setPrevBuilding}
                  onClickNext={this.setNextBuilding}
                  hasPrev={currentBuilding > 0}
                  hasNext={currentBuilding < this.buildingsArray.length - 1}
                />
                <HeaderSelector
                  value={buildings[this.buildingsArray[currentBuilding]].units[currentUnit].number}
                  onClickPrev={this.setPrevUnit}
                  onClickNext={this.setNextUnit}
                  hasPrev={currentUnit > 0}
                  hasNext={currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1}
                />
                {totalUnits > 1 && (
                  <button
                    type="button"
                    className="LfaHeader_Buttons_Next"
                    onClick={this.setNext}
                    style={{ color: ConfigService.getColor('tertiaryColor') }}>
                    Next file
                  </button>
                )}
              </div>
            </>
          )) || (
            <>
              <div className="WrapperDynamicForm_Actions Center">
                <Button className="Button_Small Inline" onClick={() => this.reopen()}>
                  REOPEN
                </Button>
              </div>
              <div className="LfaHeader_Buttons">
                <HeaderSelector
                  label="Building"
                  value={this.buildingsArray[currentBuilding]}
                  onClickPrev={() => this.setPrevBuilding(true)}
                  onClickNext={() => this.setNextBuilding(true)}
                  hasPrev={currentBuilding > 0}
                  hasNext={currentBuilding < this.buildingsArray.length - 1}
                />
                <HeaderSelector
                  value={buildings[this.buildingsArray[currentBuilding]].units[currentUnit].number}
                  onClickPrev={() => this.setPrevUnit(true)}
                  onClickNext={() => this.setNextUnit(true)}
                  hasPrev={currentUnit > 0}
                  hasNext={currentUnit < buildings[this.buildingsArray[currentBuilding]].units.length - 1}
                />
                {totalUnits > 1 && (
                  <button
                    type="button"
                    className="LfaHeader_Buttons_Next"
                    onClick={() => this.setNext(true)}
                    style={{ color: ConfigService.getColor('tertiaryColor') }}>
                    Next file
                  </button>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    );
  }
}

export default LfaHeader;
